<template>
  <div class="camera-capture">
    <!-- Video Preview -->
    <video ref="video" autoplay playsinline class="w-full rounded-md border"></video>

    <!-- Capture Button -->
    <button @click="capturePhoto" class="btn btn-primary btn-sm mt-2">
      Capture
    </button>

    <!-- Optional: Preview Captured Image -->
    <img v-if="photoDataUrl" :src="photoDataUrl" class="mt-2 w-48 h-auto border rounded" />
  </div>
</template>
<script setup>
import { ref, onBeforeUnmount, defineExpose } from "vue";

const video = ref(null);
const stream = ref(null);
const photoDataUrl = ref(null);
const emit = defineEmits(["onCaptured"]);

const cameraStarted = ref(false);

// Start camera manually
const startCamera = async () => {
  if (cameraStarted.value) return;

  console.log("Open Log")

  try {
    stream.value = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: "environment" },
      audio: false,
    });
    if (video.value) video.value.srcObject = stream.value;
    cameraStarted.value = true;
  } catch (err) {
    console.error("Camera access denied:", err);
    alert("Cannot access camera. Please allow camera permissions.");
  }
};

// Stop camera
const stopCamera = () => {
  if (stream.value) {
    stream.value.getTracks().forEach((track) => track.stop());
    cameraStarted.value = false;
  }
};

// Capture photo
const capturePhoto = () => {
  if (!video.value || !cameraStarted.value) return;

  const canvas = document.createElement("canvas");
  canvas.width = video.value.videoWidth;
  canvas.height = video.value.videoHeight;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(video.value, 0, 0, canvas.width, canvas.height);

  canvas.toBlob((blob) => {
    if (blob) {
      photoDataUrl.value = URL.createObjectURL(blob);
      emit("onCaptured", blob);
    }
  }, "image/jpeg", 0.95);
};

// Expose methods to parent
defineExpose({
  startCamera,
  stopCamera,
});
</script>
